import { useToggle } from '@alluradirect/react';
import { Typography, Grid } from '@mui/material';
import { PageHeaderHelpDialog } from 'components/layout/Page/components/PageHeaderHelpDialog';

export const CheckoutSummaryNeedAssistance = () => {
  const helpToggle = useToggle();

  return (
    <Grid item xs={12}>
      <Typography variant="body2" align="center" mt={2}>
        <strong>Need Assistance?</strong>{' '}
        <a href="#" onClick={helpToggle.open}>
          Contact Reservation Support Team
        </a>
      </Typography>
      {helpToggle.isOpen ? <PageHeaderHelpDialog isOpen={helpToggle.isOpen} close={helpToggle.close} /> : null}
    </Grid>
  );
};
